import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LogoutPageComponent } from './logout-page/logout-page.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { LoginGuard } from './guards/login.guard';
import { MfaSelectPageComponent } from './mfa-select-page/mfa-select.page.component';

const APP_ROUTES: Routes = [
  {
    path: '',
    canActivate: [LoginGuard],
    loadChildren: () => import('./authenticated/authenticated.module').then(m => m.AuthenticatedModule),
  },
  {
    path: 'error',
    component: ErrorPageComponent,
  },
  {
    path: 'registration',
    loadChildren: () => import('@markant-platform/registration/routing').then(({ routes }) => routes),
  },
  {
    path: 'mfa-select',
    component: MfaSelectPageComponent,
  },
  {
    path: 'logout',
    component: LogoutPageComponent,
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(APP_ROUTES, {
      initialNavigation: 'enabledNonBlocking', // <-- Routing should only be initialized after bootstrapping main app module
      enableTracing: false,
      anchorScrolling: 'enabled',
      bindToComponentInputs: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
